import React from 'react';
import PropTypes from 'prop-types';

import audioSinkService from '../../../../services/livesession/AudioSinkService';

/**
 * SoundButton is a generic component that disables a button during playback.
 *
 * For the button prop, it expects a component class/function that it will
 * render with a disabled prop during playback, and a onClick prop to start
 * playback.
 *
 * SoundButton expects a single <source /> element or a list of <source />
 * elements as children elements.
 *
 * It allows the component to be agnostic of the URL of the media resource.
 *
 * speakerDeviceId prop should be a device ID as defined in Audio Output API.
 */
class SoundButton extends React.PureComponent {
    static propTypes = {
        button: PropTypes.elementType.isRequired,
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element),
        ]).isRequired,
        speakerDeviceId: PropTypes.string,
    };

    static defaultProps = {
        speakerDeviceId: null,
    };

    constructor(props) {
        super(props);

        this.audioRef = React.createRef();
        this.state = {
            isPlaying: false,
        };
    }

    componentDidMount() {
        this.setSinkId();
    }

    componentDidUpdate() {
        this.setSinkId();
    }

    setSinkId() {
        audioSinkService.setSinkId(
            this.audioRef.current,
            this.props.speakerDeviceId,
        );
    }

    onAudioStatusChange = (theEvent) => {
        const audio = theEvent.target;

        this.setState({
            isPlaying: !audio.paused,
        });
    };

    play = () => {
        const audio = this.audioRef.current;

        if (!audio) {
            return;
        }

        audio.play();
    };

    render() {
        const { button: ButtonComponent, children } = this.props;
        const { isPlaying } = this.state;

        return (
            <React.Fragment>
                <ButtonComponent disabled={isPlaying} onClick={this.play} />
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <audio
                    onEnded={this.onAudioStatusChange}
                    onPause={this.onAudioStatusChange}
                    onPlay={this.onAudioStatusChange}
                    preload="auto"
                    ref={this.audioRef}
                >
                    {children}
                </audio>
            </React.Fragment>
        );
    }
}

export default SoundButton;
